module.exports = "/_next/static/images/d38806a5e489519b8d38de99ac18f91d-careers@2x.jpg";